export default "__VITE_ASSET__CfNzpHK___"